"use client";

import { usePathname } from "next/navigation";
import { Button } from "@tillix/ui-atoms/button";
import { MailIcon } from "lucide-react";
import { type FieldValues, useFormContext } from "react-hook-form";
import { useT } from "@/features/i18n/hooks/use-t";

export default function MagicLinkButton<TFieldValues extends FieldValues>() {
  const form = useFormContext<TFieldValues>();
  const { isValid, isSubmitting } = form.formState;
  const pathname = usePathname();
  const { t } = useT();

  const text = isSubmitting
    ? t("auth.sendingMagicLink")
    : pathname === "/sign-in"
      ? t("auth.signInWithMagicLink")
      : t("auth.signUpWithMagicLink");

  return (
    <Button
      className="w-full"
      disabled={!isValid || isSubmitting}
      IconRight={MailIcon}
      type="submit"
      variant="outline"
    >
      {text}
    </Button>
  );
}
